import { combineReducers, configureStore } from "@reduxjs/toolkit";
import mainReducer from "./middleware";
// import menured from "./menureducer";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";

const presistConfig = {
    key: "root",
    version: 1,
    storage,
}

const reducer = combineReducers({
    main:mainReducer,
    // menu:menured,
});

const persistedReducer = persistReducer(presistConfig, reducer);

const store = configureStore({
  devTools: process.env.NODE_ENV !== "production",
  reducer: persistedReducer,
  middleware: (getM) => getM({ serializableCheck: false }), 
});

export default store;
